/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Substatus_Package_DepartedInputs */

const tr_geliver_substatus_package_departed = /** @type {(inputs: Geliver_Substatus_Package_DepartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket Gönderildi`)
};

const en_geliver_substatus_package_departed = /** @type {(inputs: Geliver_Substatus_Package_DepartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Package Departed`)
};

const de_geliver_substatus_package_departed = /** @type {(inputs: Geliver_Substatus_Package_DepartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket abgeschickt`)
};

const ru_geliver_substatus_package_departed = /** @type {(inputs: Geliver_Substatus_Package_DepartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посылка отправлена`)
};

/**
* | output |
* | --- |
* | "Package Departed" |
*
* @param {Geliver_Substatus_Package_DepartedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_substatus_package_departed = /** @type {((inputs?: Geliver_Substatus_Package_DepartedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Substatus_Package_DepartedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_substatus_package_departed(inputs)
	if (locale === "de") return de_geliver_substatus_package_departed(inputs)
	if (locale === "ru") return ru_geliver_substatus_package_departed(inputs)
	return tr_geliver_substatus_package_departed(inputs)
});